import React, { useMemo } from 'react';
import { Button, Popconfirm, Tooltip } from 'antd';
import intl from 'react-intl-universal';

import { getExchangeActionType, ExchangeActionHint } from '@/pages/reservation/roomExchange/helper';
import {
  ConfigRoomPrice,
  ExchangeRentRoomInfo,
  ExchangeRoomRole,
} from '@/redux/reducers/reservation/base.d';
import { findItemByKey, flatPriceList } from '@/redux/actions/reservation/helper';
import { validDetailNotRequire, validDetailRequire, ReverseResonCodeQT } from '../../helper';

import styles from './index.module.scss';

interface IProps {
  onSubmit: () => void;
  btnText: string;
  rentRoomInfos: ExchangeRentRoomInfo[];
  marketPriceList: ConfigRoomPrice[];
  storeRemarks: any;
}

// 注意： 此处预订换排行 以及 入住换排房公用 需要修改需测试两种情况
const Index: React.FC<IProps> = (props) => {
  const { rentRoomInfos, marketPriceList, btnText, storeRemarks, onSubmit } = props;

  const targetRoom = useMemo(() => {
    return findItemByKey(rentRoomInfos, 'itemRole', ExchangeRoomRole.TargetRoom);
  }, [rentRoomInfos]);

  const marketPriceMap = useMemo(() => {
    return flatPriceList(marketPriceList);
  }, [marketPriceList]);

  // 禁用提交按钮
  let isDisabled = !targetRoom.roomId || !storeRemarks?.changeReasonCode;

  //  选的是“其他”选项，则详情必填 选的是“其他”以外的选项，则详情选填
  if (storeRemarks?.changeReasonCode && storeRemarks?.changeReasonCode !== ReverseResonCodeQT) {
    // 详情选填
    isDisabled = isDisabled || validDetailNotRequire(storeRemarks?.changeDetail);
  } else {
    // 详情必填
    isDisabled = isDisabled || validDetailRequire(storeRemarks?.changeDetail);
  }

  const content = (
    <Button type="primary" disabled={isDisabled}>
      {btnText}
    </Button>
  );

  const isRoomNil = !targetRoom.roomId;
  if (isRoomNil) {
    return (
      <Tooltip trigger="hover" title={intl.get('drawer_exchange_error_room_null')}>
        {content}
      </Tooltip>
    );
  }

  if (!storeRemarks?.changeReasonCode) {
    return (
      <Tooltip trigger="hover" title={intl.get('drawer_exchange_remark_exchange_type_placeholder')}>
        {content}
      </Tooltip>
    );
  }

  if (storeRemarks?.changeReasonCode === ReverseResonCodeQT && !storeRemarks?.changeDetail) {
    return (
      <Tooltip
        trigger="hover"
        title={intl.get('drawer_exchange_remark_please_input_exchange_detail_label')}
      >
        {content}
      </Tooltip>
    );
  }

  const actionType = getExchangeActionType(rentRoomInfos, marketPriceMap);
  if (actionType === '0') {
    return (
      <Button type="primary" disabled={isDisabled} onClick={onSubmit}>
        {btnText}
      </Button>
    );
  }

  return (
    <Popconfirm
      trigger="click"
      placement="topLeft"
      title={
        <div className={styles.exchangeTypeMessage}>
          {intl.getHTML('drawer_exchange_confirm_content', {
            style: styles.typeText,
            type: ExchangeActionHint[actionType],
          })}
        </div>
      }
      onConfirm={onSubmit}
      overlayClassName={styles.exchangePopConfirm}
    >
      {content}
    </Popconfirm>
  );
};

export default Index;
